module.exports = __webpack_public_path__ + "static/img/house2.6a54b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/house2.jpg
// module id = 1Xxa
// module chunks = 0